import { getCookie } from "./getCookie";
import Cookies from "universal-cookie";
import { createRefreshApi } from "./createRefreshApi";
import { useAppStore } from "../../appStore";
import { logger } from "../../utils/logger";

export const getRefreshTokenWhenConcurrentAPICalls = async (
  navigate: any,
  retryFunction: any
) => {
  const ActuateUI = createRefreshApi(``);
  const refreshToken = getCookie("token_secret");
  const cookies = new Cookies();
  const article = { refresh_token: refreshToken };

  if (refreshToken) {
    const setRefreshingToken = useAppStore.getState().setRefreshingToken;
    await ActuateUI.post(`/auth/refresh/`, article)
      .then(async (response) => {
        const apiResponse = response.data;
        cookies.set("token", apiResponse.token, { path: "/", maxAge: 3600 });
        localStorage.setItem(`token`, apiResponse.token);
        cookies.set("token_secret", apiResponse.token_secret, {
          path: "/",
        });
        localStorage.setItem(`token_secret`, apiResponse.token_secret);
        localStorage.setItem("tokenRefreshing", "false");
        setRefreshingToken(false);

        if (retryFunction) {
          retryFunction();
        }
      })
      .catch((err) => {
        logger.log(err);
        localStorage.removeItem("loggedIn");
        localStorage.setItem("tokenRefreshing", "false");
        setRefreshingToken(false);
        // Redirect to Cognito instead of /login
        import("../pages/Login").then(({ handleRedirect }) => {
          handleRedirect();
        });
      });
  } else {
    localStorage.setItem("tokenRefreshing", "false");
    localStorage.removeItem("loggedIn");
    // Redirect to Cognito instead of /login
    import("../pages/Login").then(({ handleRedirect }) => {
      handleRedirect();
    });
  }
};
